import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/avatars/avatar-2.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

import { useDark } from "@vueuse/core";
import { ref } from "vue";

const __default__ = {
  name: "TcVsSidebar",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sidebarData: {},
    sidebarActive: {}
  },
  setup(__props: any) {

// 夜间模式仓
const isDark = useDark();
const sidebarActive = ref("index");


return (_ctx: any,_cache: any) => {
  const _component_vsIconHierarchySquare2Bold = _resolveComponent("vsIconHierarchySquare2Bold")!
  const _component_vs_icon = _resolveComponent("vs-icon")!
  const _component_vs_sidebar_item = _resolveComponent("vs-sidebar-item")!
  const _component_vs_sidebar_group = _resolveComponent("vs-sidebar-group")!
  const _component_vsIconMessages = _resolveComponent("vsIconMessages")!
  const _component_vs_avatar = _resolveComponent("vs-avatar")!
  const _component_vs_row = _resolveComponent("vs-row")!
  const _component_vs_sidebar = _resolveComponent("vs-sidebar")!

  return (_openBlock(), _createBlock(_component_vs_sidebar, {
    class: _normalizeClass(["market-sidebar", _unref(isDark) ? 'header-navbar-dark' : 'header-navbar']),
    absolute: "",
    right: "",
    "hover-expand": "",
    reduce: "",
    modelValue: sidebarActive.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sidebarActive).value = $event)),
    open: ""
  }, {
    logo: _withCtx(() => [
      _createVNode(_component_vs_icon, {
        style: _normalizeStyle({
          color: !_unref(isDark) ? 'rgba(5, 5, 5, 0.76)' : 'rgb(238,233,233)',
          fontSize: '40px',
        })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vsIconHierarchySquare2Bold)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_vs_row, { style: { width: '100%', justifyContent: 'space-between' } }, {
        default: _withCtx(() => [
          _createVNode(_component_vs_avatar, {
            "badge-color": "danger",
            "badge-position": "top-right"
          }, {
            badge: _withCtx(() => [
              _createTextVNode(" 26 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_vs_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconMessages)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_vs_avatar, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarData.menu, (items) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: items.id
        }, [
          (!items.children)
            ? (_openBlock(), _createBlock(_component_vs_sidebar_item, {
                key: 0,
                id: items.id
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(items.icon)
                  }, null, 2)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(items.title)), 1)
                ]),
                _: 2
              }, 1032, ["id"]))
            : (_openBlock(), _createBlock(_component_vs_sidebar_group, {
                key: 1,
                class: _normalizeClass(_unref(isDark) ? 'header-navbar-dark' : 'header-navbar')
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_vs_sidebar_item, {
                    arrow: "",
                    id: items.id
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(items.icon)
                      }, null, 2)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(items.title)), 1)
                    ]),
                    _: 2
                  }, 1032, ["id"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.children, (item) => {
                    return (_openBlock(), _createBlock(_component_vs_sidebar_item, {
                      key: item.id,
                      id: item.id
                    }, {
                      icon: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(item.icon)
                        }, null, 2)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                      ]),
                      _: 2
                    }, 1032, ["id"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["class"]))
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["class", "modelValue"]))
}
}

})